import { makeStyles } from 'tss-react/mui';

import { scrollBar } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  modal: {
    height: 'initial',
    flexGrow: 1,
    ...scrollBar,
  },
}));

export default useStyles;
